import React from 'react';
import { connect, useDispatch } from 'react-redux';

import SearchQueryEntry from '~/components/AnalyzerPage/SearchQueryEntry/SearchQueryEntry';
import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';
import searchSlice from '~/redux/slices/search';
import { useRouting } from '~/routing/useRouting';

const EditInAnalyzer = ({ query, analyzerSetData: setAnalyzerFormData }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { navigate } = useRouting();

  const resetSearchPage = () => {
    dispatch(searchSlice.actions.reset());
  };

  const applyQueryInAnalyzerForm = () => {
    setAnalyzerFormData({ filters: query });
    navigate('/analyzer');
  };

  return (
    <Layout align="center" spacing={3} wrap={true}>
      <SearchQueryEntry query={query} />
      <Button
        text={intl.formatMessage({
          id: 'EditInAnalyzer.editButton',
          defaultMessage: 'Edit in Analyzer',
          description: 'Button text to edit query in analyzer',
        })}
        variant="action"
        onClick={applyQueryInAnalyzerForm}
      />
      <Button
        text={intl.formatMessage({
          id: 'EditInAnalyzer.clearFiltersButton',
          defaultMessage: 'Clear Filters',
          description: 'Button text to clear all filters',
        })}
        variant="action"
        onClick={resetSearchPage}
      />
    </Layout>
  );
};

const mapStateToProps = ({ analyzer }) => ({ analyzer });

export default connect(mapStateToProps, {
  analyzerSetData: slices.analyzer.actions.setData,
})(EditInAnalyzer);
